export const NAMESPACE = "TeamUserInfoModal";

export const FIELDS = {
  ROLE: "role",
  PERMISSION_ROLE: "permission_role",
  API_TOKEN: "api_token",
  ENABLE_API: "enable_api"
};
